<template>
    <div class="user-course lesson-tab-box">
        <div class="right-btn">
            <el-button class="add-lesson-btn" v-if="activeName=='course'" type="primary" icon="el-icon-plus" size="small" @click="beforeAdd">创建课程</el-button>
            <el-button class="add-lesson-btn" v-if="activeName=='course'" type="primary" icon="el-icon-plus" size="small" @click="beforeExpAdd">创建实验</el-button>
            <el-button class="add-lesson-btn" v-if="activeName=='tag'" type="primary" icon="el-icon-plus" size="small" @click="beforeTagAdd">创建标签</el-button>
            <el-button class="add-lesson-btn" v-if="activeName=='template'" type="primary" icon="el-icon-plus" size="small" @click="beforeTempAdd">创建报告模版</el-button>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-if="setDept" label="我的课程" name="course"></el-tab-pane>
            <el-tab-pane v-if="setDept" label="公开课程" name="public"></el-tab-pane>
            <el-tab-pane v-if="setDept" label="实验标签" name="tag"></el-tab-pane>
            <el-tab-pane label="报告模版" name="template"></el-tab-pane>
            <component :is="tabs[activeName]" :data="data" @handJump="handJump" @handleEdit="handleEdit" @handleDelete="handleDelete" @handPageChange="handPageChange" @handTagEdit="handTagEdit" @handTagDelete="handTagDelete" @handTempEdit="handTempEdit" @handTempRomve="handTempRomve" @handleSee="handleSee"/>
        </el-tabs>
        <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper" :total="page.total" :current-page="page.page" :page-size="page.limit" :pager-count="page.pagerCount" @current-change="handPageChange" style="margin-top:15px" hide-on-single-page></el-pagination>
        <!-- 课程弹窗 -->
        <el-dialog title="课程" :visible.sync="courseOpen" width="30%">
           <el-form :model="courseForm" :rules="courseRules" label-width="80px" ref="courseForm">
                <el-form-item label="课程名称" prop="courseName">
                    <el-input v-model="courseForm.courseName"  placeholder="请输入课程名称"></el-input>
                </el-form-item>
                <el-form-item label="是否公开" prop="publicCourse">
                    <el-select style="width: 78%;" v-model="courseForm.publicCourse" filterable placeholder="请选择项目是否公开">
                        <el-option v-for="item in pubilcStatus" :key="item.id" :label="item.label" :value="item.id" disabled></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="courseOpen = false">取 消</el-button>
                <el-button type="primary"  @click="submitCourse">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 标签弹窗 -->
        <el-dialog title="标签" :visible.sync="tagOpen" width="30%">
            <el-form :model="tagForm" :rules="tagRules" label-width="80px" ref="tagForm">
                <el-form-item label="标签名称" prop="tagName">
                    <el-input v-model="tagForm.tagName"  placeholder="请输入标签名称"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="tagOpen = false">取 消</el-button>
                <el-button type="primary"  @click="submitTag">确 定</el-button>
            </span>
        </el-dialog>
        <expResourceDialog ref="expResourceDialog" :dataForm="dataForm" @itemChange="getCourseList"/>
        <expTemplateDialog ref="expTemplateDialog" :jsonData="jsonData" @handSave="handSave"/>
        <expPreview ref="expPreview" :dataData="dataData" :preData="preData" :isdisable="true"/>
    </div>
</template>

<script>
import { getList, remove, update, add, duplicateCheck} from "@/api/exp/course";

import { getEntity, getList as tagGetList, remove as tagRomve, update as tagUpdate, add as tagAdd, duplicateCheck as tagDuplicateCheck } from "@/api/exp/exptag";

import expCourse from './components/exp-course'
import expPublic from './components/exp-public'
import expTag from './components/exp-tag'
import expTemplate from './components/exp-template'

import { mapGetters }  from 'vuex'
import  expResourceDialog  from './components/exp-resource-dialog'  //实验项目dialog
import  expTemplateDialog  from './components/exp-template-dialog'  //实验模版dialog
import expPreview from './components/exp-preview-dialog'   //实验预览dialog


import { query , add as templateAdd ,  remove as templateRomve , update as templateUpdate , getDetail } from "@/api/lab/experimentreportmould"

export default {
  data() {
        const validateCourseName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入课程'));
            } else {
                //远程验证课程名称是否存在
                duplicateCheck({id: this.courseForm.id, courseName: value}).then(res => {
                    if(res) {
                        callback(new Error('课程已存在，请重新输入'));
                    }
                    callback();
                })
            }
        }
        const validateTagName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入课程'));
            } else {
                //远程验证课程名称是否存在
                tagDuplicateCheck({id: this.tagForm.id, tagName: value}).then(res => {
                    if(res) {
                        callback(new Error('课程已存在，请重新输入'));
                    }
                    callback();
                })
            }
        }
        return {
            tabs: {
                course: 'expCourse',
                public: 'expPublic',
                tag: 'expTag',
                template: 'expTemplate'
            },
            data:[],
            courseForm:{
                courseName: '',
                publicCourse: 0
            },
            tagForm:{
                tagName: '',
            },
            courseOpen:false,  //课程弹窗
            tagOpen:false,  //标签弹窗
            activeName:'template',
            page:{
                page: 1,
                limit: 8,
                total: 0
            },
            pubilcStatus: [
                { id: 0, label: '不公开' },
                { id: 1, label: '公开' }
            ],
            courseId:null,
            courseList:[],
            tagList:[],
            pubCourseList:[],
            courseRules: {  //课程规则
                courseName: [
                    { required: true, validator: validateCourseName, trigger: "blur" }
                ],
            },
            tagRules: {  //标签规则
                tagName: [
                    { required: true, validator: validateTagName, trigger: "none" }
                ],
            },
            dataForm : {},
            jsonData:{},
            preData:{},
            dataData:{
                content:{}
            }
        }
    },
    components:{
        expResourceDialog,
        expCourse,
        expPublic,
        expTag,
        expTemplate,
        expTemplateDialog,
        expPreview
    },
    computed:{
        ...mapGetters(['userInfo', 'isAdmin', 'isTeacher']),
        setDept(){
          // TODO 我的课程 公开课程 实验标签
            // const { deptId, roles } = this.userInfo
            // let deptIds = [0,1,2,3]
            // let a = deptIds.indexOf(deptId) > -1
            // let b = roles.indexOf(6) > -1
            // return a || b
          return this.isAdmin || this.isTeacher
        },
    },
    created(){
        this.beforeChange()
    },
    methods:{
        handleSee(val){
            getDetail(val.id).then((res)=>{
                this.preData = res
                this.$refs['expPreview'].changeVisible(true)
            })
        },
        handleClick(i){
            this.activeName = i.name
            this.handPageChange(1)
        },
        beforeChange(){
            if (this.activeName == 'course') this.getCourseList()
            else if (this.activeName == 'public') this.getPubCourseList()
            else if (this.activeName == 'tag') this.getTagList()
            else if (this.activeName == 'template') this.getReportTemplate()
        },
        submitCourse(){  //提交课程表单
            this.$refs['courseForm'].validate((valid) => {
                if (valid) {
                    let op = add
                    if (this.courseForm.id) op = update
                    op(this.courseForm).then(res => {
                        this.courseForm.courseId = res;
                        this.$message.success('操作成功!');
                        this.courseOpen = false
                        this.getCourseList()
                    })
                }
            })
        },
        submitTag(){ //提交标签表单
            this.$refs['tagForm'].validate((valid) => {
                if (valid) {
                    let op = tagAdd
                    if (this.tagForm.id) op = tagUpdate
                    op(this.tagForm).then(res => {
                        this.tagForm.tagId = res;
                        this.$message.success('操作成功!');
                        this.tagOpen = false
                        this.getTagList()
                    })
                }
            })
        },
        handPageChange(page){ //点击课程切换分页
            this.$set(this.page, 'page', page)
            this.beforeChange()
        },
        handleEdit(row){
            this.courseForm = {
                id: row.id,
                courseName: row.courseName,
                publicCourse: row.publicCourse ? 1 : 0
            }
            this.courseOpen = true
        },
        handTagEdit(row){
            getEntity(row.id).then(res => {
                this.tagForm = res
            })
            this.tagOpen = true
        },
        handTempEdit(val){
            getDetail(val.id).then(res =>{
                let data = res
                delete data.createTime
                this.jsonData = data
                this.$refs['expTemplateDialog'].changeVisible(true)
            })
        },
        handTempRomve(val) {  //删除模版操作
            this.$confirm('此操作将删除该报告模版,并且已关联的实验报告将不可用,请谨慎操作!', {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                return templateRomve(val.id);
            }).then(() => {
                this.getReportTemplate()
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
            });
        },
        handJump(row){
            this.courseId = row.id
            this.$router.push(`/resource/${row.id}`)
        },
        handSave(data){   //保存模版
            if(data.config.name && data.config.passScore) {
                data.list.map(item=>{
                    if(item.type==="checkbox") item.defaultValue = []
                    else item.defaultValue = ""
                })
                let dataJson = JSON.stringify(data)  //json内容json格式
                let dataForm = {
                    ...this.jsonData,
                    name:data.config.name,
                    score:data.config.score,
                    passScore:data.config.passScore,
                    topicNum:data.list.length,
                    content: dataJson,
                }
                let op = templateAdd
                if (dataForm.id) op = templateUpdate
                op(dataForm).then(()=>{
                    this.$message.success("操作成功");
                    this.$refs['expTemplateDialog'].changeVisible(false)
                    this.getReportTemplate()
                })
            }else{
                this.$message.warning("请填写模版名称,并设置及格分!");
            }
        },
        handleDelete(row){
            this.$confirm(`${row.expNum>0?'此操作将删除该课程下所有实验':'确定将选择数据删除'}`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                return remove(row.id);
            }).then(() => {
                this.getCourseList()
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
            });
        },
        handTagDelete(row){
            this.$confirm("确定将选择数据删除?", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
            }).then(() => {
                return tagRomve([row.id]);
            }).then(() => {
                this.getTagList()
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
            });
        },
        beforeAdd(){  //创建课程
            this.courseOpen = true
            this.courseForm = {
                courseName: '',
                publicCourse:0
            }
        },
        beforeTagAdd(){  //创建标签
            this.tagOpen = true
            this.tagForm = {
                tagName: '',
            }
        },
        beforeExpAdd(){  //创建实验项目
            this.dataForm = {}
            this.$refs['expResourceDialog'].changeVisible(true)
        },
        beforeTempAdd(){
            this.jsonData = {
                content:'{"list":[],"config":{"labelWidth":100,"labelPosition":"top","size":"small","customClass":"","passScore":0,"score":0,"goal":0 }}'
            }
            this.$refs['expTemplateDialog'].changeVisible(true)
        },
        getReportTemplate(){  //获取报告模版
            const { page,limit } = this.page
            const { userInfo } = this
            query(page, limit, {
                createUser: userInfo.id
            }).then(res=>{
                const { totalCount , list} = res
                this.data = list
                this.$set(this.page,'total',totalCount)
                this.data.forEach((item,index)=>{
                    item.index = index + 1 + (page - 1) * limit
                    return item
                })
            })
        },
        getCourseList(){ //获取课程列表
            const { page,limit } = this.page
            getList(page, limit, {
                createUser: this.userInfo.id
            }).then(res => {
                const { totalCount , list} = res
                this.data = list
                this.$set(this.page,'total',totalCount)
                this.data.forEach((item,index)=>{
                    item.index = index + 1 + (page - 1) * limit
                    return item
                })
            });
        },
        getPubCourseList(){  //公开课程列表
            const { page,limit } = this.page
            getList(page, limit, {
                isPublic: 1,
                status:1
            }).then(res => {
                const { totalCount , list} = res
                this.data = list
                this.$set(this.page,'total',totalCount)
                this.data.forEach((item,index)=>{
                    item.index = index + 1 + (page - 1) * limit
                    return item
                })
            });
        },
        getTagList(){ //获取标签列表
            const { page,limit } = this.page
            tagGetList(page, limit, {
                createUser: this.userInfo.id
            }).then(res => {
                const { totalCount , list} = res
                this.data = list
                this.$set(this.page,'total',totalCount)
                this.data.forEach((item,index)=>{
                    item.index = index + 1 + (page - 1) * limit
                    return item
                })
            });
        }
    }
}
</script>
<style lang="less">
    .user-course{
        .right-btn {
            z-index: 998;
        }
    }
</style>
